<div class="banner {{ color }}">
    {{ text }}
</div>